export class QBGJournal {
  constructor() {
    this.fJournalChanged = false;
    this.fBGMgr = null;
    this.fBackground = null;
  }

  InitJournal(bgMgr) {
    this.fBGMgr = bgMgr;
  }

  GetUpdateCode() {
    var updateCode = null;
    //if (this.fBackgroundChanged == true) updateCode = 1;

    return updateCode;
  }

  JournalChanged() {
    return this.fJournalChanged;
  }

  BackgroundChanged(background) {
    if (this.fBackground == null) {
      this.fBackground = background.Clone();
      this.fJournalChanged = true;
    }
  }

  Restore() {
    if (this.fBackground != null) {
      this.fBGMgr.SetActiveBackground(
        this.fBackground,
        this.fBGMgr.GetCurBackgroundName(),
        this.fBackground.GetPageProps(),
        false
      );
      this.fBGMgr.BroadcastCurrentAreas();
    }
    if (this.fJournalChanged === true) this.fBGMgr.JournalChanged();
  }
}
